/**
 * geetest plugin
 *
 * @author Shigq
 * @date 2022/4/22 16:36
 */
import { gtInit, GT_MAP } from 'sr-plugin-geetest'
import { user } from '@/api/url'
import { useI18n } from './i18n'

const { gt: { locale } } = useI18n()

export default () => {
  gtInit(() => {
    const env = process.env.VUE_APP_GT4_ENV === 'production' ? 'PRO' : 'DEFAULT'
    const baseURL = process.env.VUE_APP_BASE_URL
    const captchaMap = GT_MAP[env]
    const interfaceCaptchaMap = {
      [user.sendMobilePhoneCode]: captchaMap.VERIFY,
      [user.sendEmailCode]: captchaMap.VERIFY_INS,
      [user.login]: captchaMap.VERIFY_INS,
    }

    return {
      interfaceCaptchaMap,
      baseURL,
      locale
    }
  })
}
